import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  Divider,
  Avatar,
} from "@mui/material";
import {  CaretRight, XCircle } from "@phosphor-icons/react";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { connect } from "react-redux";
import { setUserlistShow } from "../../../../../Redux/Actions/actions";
import EndChatModel from "../../chat-component-model/End-chat-model";

const StyledDivider = styled(Divider)(({ theme }) => ({
  "& .MuiDivider-root": {
    height: "35px !important",
  },
}));


const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    userlistshow: data.userlistshow,
    externalChatData: contactListData.externalChatData,
  };
};

const VideoChatConversationHeader = (props) => {
  const [endchatModalDialog, setendchatModalDialog] = useState(false);

  const EndChatDialogClose = () => {
    setendchatModalDialog(false);
  };

  return (
    <>
      <Box
        sx={{
          height: "max-content",
          width: "100%",
          backgroundColor: "#FFFF",
          borderRadius: 0.9,
          boxShadow: "0px 0px 2px rgba(0,0,0,0.25)",
        }}
        p={1}
      >
        <Stack
          alignItems={"center"}
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <Stack direction={"row"} sx={{ width: "100%" }}>
            <Stack direction={"row"} spacing={1} sx={{ flexGrow: 1 }}>
              <Avatar
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  background: "#0B3363",
                }}
              >
                {props.externalChatData
                  ? props.externalChatData.unique_id
                    ? props.externalChatData.unique_id.username
                        .slice(0, 2)
                        .toUpperCase()
                    : ""
                  : ""}
              </Avatar>
              <Stack
                spacing={0.1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, fontSize: "12px" }}
                >
                  {props.externalChatData
                    ? props.externalChatData.unique_id
                      ? props.externalChatData.unique_id.username
                      : ""
                    : ""}
                </Typography>
              </Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"}>
              <Tooltip title="End Interaction" arrow placement="top">
                <IconButton
                  onClick={() => {
                    setendchatModalDialog(true);
                  }}
                >
                  <XCircle size={15} weight="bold" />
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>

          <Stack direction={"row"}>
            <StyledDivider
              orientation="vertical"
              flexItem
              sx={{ height: "30px !important" }}
            />

            <IconButton
              onClick={() => {
                props.setUserlistShow(!props.userlistshow);
              }}
            >
              <CaretRight
                size={15}
                className={
                  props.userlistshow
                    ? "userInfo-rotate-90"
                    : "userInfo-rotate-0"
                }
              />
            </IconButton>
          </Stack>
        </Stack>
      </Box>

      {endchatModalDialog && (
        <EndChatModel
          OpenDialog={endchatModalDialog}
          handleClose={EndChatDialogClose}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, { setUserlistShow })(
  VideoChatConversationHeader
);
